import RSA from './rsa.js';
let CryptoJS = require('./crypto-js.js');
var RSA_PUBLIC =
  '-----BEGIN PUBLIC KEY-----\
    MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgGj8WNUSzCn0rHqfIXk9XPdJp60u\
    JnM+mVZVxY1lZmUCVA7t3eJZ0R0z1hUHkVb51eryDZcsz0QLSav3cmQv00ullK18\
    8aOs2SXZe6rcQf6XmOsVBqgADkrN+WePZJmb5Fr0NUkQ/sr7+R71cDZ87Y9QKm99\
    8BFOiWoEGxWWvDsTAgMBAAE=\
        -----END PUBLIC KEY-----';

import axios from 'axios';
var surl = window.location.href;
var obj = {};
var urls = surl.substr(surl.indexOf('?') + 1).split('&');
for (var i = 0; i < urls.length; i++) {
  var temp = urls[i].split('=');
 obj[temp[0]] = temp[1];
}
// obj.token = 'bearer e37c6a53-99c9-4f4c-a1d3-eeac5cd0cd12'
// obj.user_id = '320433'
// obj.version = '293'
// 去除不必要的传参 
// 青春泡泡相关
if(window.location.href.indexOf('/youthBlindBox') > -1){
  delete obj['cityCode']
  delete obj['active']
  delete obj['single']
  delete obj['openBox']
}

const reqAxios = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})
  // reqAxios.defaults.baseURL = 'http://kshtest.lanlingcb.com/dsgc'
  // reqAxios.defaults.baseURL = 'https://prellcb.kaishuihu.com/dsgc'



let token = obj.token || '';
// 响应拦截
reqAxios.interceptors.response.use(
  (response) => {
    // console.log(response,'状态码')
    // 对响应数据做点什么
    if (response.status === 200) {
      //响应成功后
      if (response.headers['token']) {
        //获取响应头里面的数据，**Authorization根据你响应头里面的数据获取，并不是唯一值**
        sessionStorage.setItem('token', response.headers['token']);
      }
      return Promise.resolve(response);
    } else if (response.data.code === 401) {
      alert('请重新登录');
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    // 对响应错误做点什么
    if (error) {
      switch (error.code) {
        case 401:
          alert('请重新登录');
      }
    }
    return Promise.reject(error.data);
  }
);

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postRequest({ url, data = {} }) {
  let formData = new FormData();
  Object.assign(data, obj);
  
  console.log('data', data, 'url', url);
  // 要加密（RSA）的随机字符串privateKey（随机生成）
  var timestamp = new Date().getTime();
  var randomStr = CryptoJS.MD5(timestamp.toString()).toString();
  var privateKey = RSA.encrypt(randomStr, RSA.getPublicKey(RSA_PUBLIC));
  reqAxios.defaults.headers.post['privateKey'] = privateKey;
  var a = Date.now();
  if (window.location.href.indexOf('/wechat') > -1) {
    sessionStorage.setItem('postId',obj.postId)
    data.accessType = 4
    data.url = window.location.href
    var encrypt = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      CryptoJS.enc.Utf8.parse(randomStr),
      {
        iv: CryptoJS.enc.Utf8.parse(randomStr.substr(0, 16)),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    var sign = encrypt.toString(); //加密后的数据
    formData.append('sign', sign);
  } else {
    // 要加密（RSA）的随机字符串privateKey（随机生成）
    if (token && token != '') {
      reqAxios.defaults.headers.post['token'] = decodeURIComponent(token);
      reqAxios.defaults.headers.post['Authorization'] = decodeURIComponent(token);
    }
    reqAxios.defaults.headers.post['version'] = obj.version;
    let ocj = {
      privateKey: privateKey,
      sendTime: a,
      user_id: obj.user_id,
    };
    Object.assign(data, ocj);
    let encrypt = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      CryptoJS.enc.Utf8.parse(randomStr),
      {
        iv: CryptoJS.enc.Utf8.parse(randomStr.substr(0, 16)),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    let sign = encrypt.toString(); //加密后的数据
    formData.append('sign', sign);
  }
  return new Promise((resolve, reject) => {
    reqAxios
      .post(url, formData)
      .then((res) => {
        // console.log('请求地址', url, '参数', data, '结果：', res.data);
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}


var protocol = window.location.protocol
console.log(process.env.NODE_ENV)
var baseURL = ''
if (process.env.NODE_ENV == 'test') {
    baseURL = protocol + "//kshtest.lanlingcb.com";
} else if (process.env.NODE_ENV == 'staging') {
    baseURL = protocol + "//preuser.kaishuihu.com";
} else if (process.env.NODE_ENV == 'production') {
    baseURL = protocol + "//user.kaishuihu.com";
} else if (process.env.NODE_ENV == 'development') {
    baseURL = protocol + "//kshtest.lanlingcb.com";
} else {
    baseURL = protocol + "//user.kaishuihu.com";
}
obj.baseURL = baseURL
// baseURL = 'http://kshtest.lanlingcb.com/dsgc'
  // baseURL = 'https://prellcb.kaishuihu.com/dsgc'
// 创建axios实例
const instance = axios.create({
    baseURL: baseURL, // 根据您的实际情况设置基础URL
    timeout: 30000 // 设置请求超时时间
});
instance.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";


// 响应拦截器
instance.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        if (response.status === 200) {
            //响应成功后
            return Promise.resolve(response);
        } else if (response.data.code === 401) {
            alert('请重新登录');
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        // 对响应错误做点什么
        if (error) {
            console.log(error)
            switch (error.code) {
            case 401:
                alert('请重新登录')
            }
        }
    }
);

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

export function post({ url, data = {} }) {
    if(window.location.href.indexOf('/register') > -1){
        data.inviteUserId = obj.user_id
        if(process.env.VUE_APP_API_URL == 'https://llcbdev.lanlingcb.com/dsgc'){
            data.env = 'dev'
        }else if(process.env.VUE_APP_API_URL == 'https://kshtest.lanlingcb.com/dsgc'){
            data.env = 'test'
        }else if(process.env.VUE_APP_API_URL == 'https://prellcb.kaishuihu.com/dsgc'){
            data.env = 'gray'
        }else if(process.env.VUE_APP_API_URL == 'https://llcb.kaishuihu.com/dsgc'){
            data.env = 'prod'
        }
        data.code = obj.user_id
        console.log(data,'data')
    }

    let formData = new FormData();
    Object.assign(data, obj);
    var timestamp = new Date().getTime();
    var randomStr = CryptoJS.MD5(timestamp.toString()).toString();
    var privateKey = RSA.encrypt(randomStr, RSA.getPublicKey(RSA_PUBLIC));
    instance.defaults.headers.post['privateKey'] = privateKey;
    if (token && token != '') {
      reqAxios.defaults.headers.post['token'] = decodeURIComponent(token);
      reqAxios.defaults.headers.post['Authorization'] = decodeURIComponent(token);
    }
    var a = Date.now();
    let ocj = {
        sendTime: a,
        version: obj.version,
        os: 'wxapplet_happy_group',
        userId: obj.user_id,
        device:'device',
    }
    Object.assign(data, ocj);
    var encrypt = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        CryptoJS.enc.Utf8.parse(randomStr),
        {
          iv: CryptoJS.enc.Utf8.parse(randomStr.substr(0, 16)),
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
    );
    var sign = encrypt.toString(); //加密后的数据
    formData.append('sign', sign);
    return new Promise((resolve, reject) => {
        instance
          .post(url, formData)
          .then((res) => {
            // console.log('请求地址', url, '参数', data, '结果：', res.data);
            resolve(res.data);
          })
          .catch((err) => {
            reject(err.msg);
          });
      });
}